module.exports = __webpack_public_path__ + "static/media/vons.b10e1933.svg";